export default angular
  .module('doxy.common.services.stats', [])
  .factory('stats', function () {
    return {
      median: function (array) {
        if (array.length < 1) return 0;
        array.sort((a, b) => a - b);
        const lowMiddle = Math.floor((array.length - 1) / 2);
        const highMiddle = Math.ceil((array.length - 1) / 2);
        return (array[lowMiddle] + array[highMiddle]) / 2;
      },

      mean: function (array) {
        if (array.length < 1) return 0;
        const sum = array.reduce((previous, current) => (current += previous));
        return sum / array.length;
      },

      variance: function (array) {
        if (array.length < 1) return 0;
        const mean = this.mean(array);
        return this.mean(array.map((num) => Math.pow(num - mean, 2)));
      },

      stdev: function (array) {
        if (array.length < 1) return 0;
        return Math.sqrt(this.variance(array));
      },
    };
  }).name;
